<template>
    <v-container class="overflow-auto pa-5 ma-0">
        <h4>{{ $t('metadata_for', { title: record?.fullname }) }}</h4>
        <table class="stripe-table mt-2 tgk-paragraph-text">
            <tbody>
                <tr>
                    <td>{{ $t('rec_id') }}</td>
                    <td>{{ record?.id }}</td>
                </tr>
                <tr>
                    <td>{{ $t('username') }}</td>
                    <td>{{ record?.username }}</td>
                </tr>
                <tr>
                    <td>{{ $t('created') }}</td>
                    <td>
                        {{ record?.created.formatIf('dd, DD.MM.YYYY HH:mm') }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('modified') }}</td>
                    <td>
                        {{ record?.modified.formatIf('dd, DD.MM.YYYY HH:mm') }}
                    </td>
                </tr>
                <tr>
                    <td>{{ $t('last_login') }}</td>
                    <td>{{ record?.last_login.formatIf('dd, DD.MM.YYYY HH:mm') }}</td>
                </tr>
                <tr>
                    <td>{{ $t('login_count') }}</td>
                    <td>{{ record?.login_count }}</td>
                </tr>
                <tr>
                    <td>{{ $t('initials') }}</td>
                    <td>{{ record?.initials }}</td>
                </tr>
                <tr>
                    <td>{{ $t('sprache') }}</td>
                    <td>{{ record?.locale }}</td>
                </tr>
            </tbody>
        </table>
    </v-container>
</template>

<script>
import { User } from '@/models/User';
import getRulesMixin from '@/mixins/get-form-rules';

export default {
    name: 'UserMetadata',
    components: {},
    mixins: [getRulesMixin],

    props: {
        record: {
            type: User,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped></style>
